module.exports = __webpack_public_path__ + "static/media/c-and-l-bay-view-inn.05c0752f.jpg";